export default "__VITE_ASSET__CJm4nfaC__"